var ne = Object.defineProperty;
var se = (t, e, s) => e in t ? ne(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var _ = (t, e, s) => se(t, typeof e != "symbol" ? e + "" : e, s);
import { reactive as X, computed as I, ref as oe, onMounted as H, onUnmounted as P, defineComponent as V, createBlock as K, createCommentVNode as re, openBlock as R, unref as T, withCtx as ce, createElementBlock as L, Fragment as M, renderList as j, withModifiers as ae, normalizeClass as B, toDisplayString as G, createTextVNode as ie, watch as ue, withDirectives as le, vShow as de, createApp as ge } from "vue";
import he from "@constructor-io/constructorio-client-javascript";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { CdrList as pe } from "@rei/cedar";
const fe = (t, e = 300, s = 1e3) => {
  let n, o, i, m, h = 0;
  const l = () => {
    n && clearTimeout(n), o && clearTimeout(o), n = void 0, o = void 0;
  }, p = (v, u) => {
    l(), h = Date.now(), Promise.resolve(t.apply(m, i)).then(v).catch(u);
  };
  return function(...u) {
    i = u, m = this;
    const f = Date.now();
    h === 0 && (h = f);
    const A = f - h;
    return new Promise((w, x) => {
      if (A >= s) {
        p(w, x);
        return;
      }
      n && clearTimeout(n), n = setTimeout(() => p(w, x), e), o || (o = setTimeout(() => p(w, x), s - A));
    });
  };
}, C = /* @__PURE__ */ new Map();
let D = null;
const Y = (t) => {
  var n, o;
  if (t === "" || !t) return {};
  const e = (n = window == null ? void 0 : window.document) == null ? void 0 : n.querySelector(t), s = (e == null ? void 0 : e.getAttribute("type")) === "application/json";
  if (!e || !(e instanceof HTMLScriptElement) && !s)
    return {};
  try {
    const i = JSON.parse((o = e.textContent) == null ? void 0 : o.trim());
    return D = i, typeof i != "object" || i === null || Array.isArray(i) ? (console.error(`Invalid JSON structure in script tag with ID: ${e.id}`), {}) : i;
  } catch (i) {
    return console.error(`Failed to parse JSON from script tag with ID: ${D == null ? void 0 : D.key}`, i), {};
  }
}, k = (t) => {
  if (C.has(t))
    return C.get(t);
  try {
    const e = document.querySelector(t);
    if (e instanceof HTMLElement)
      return C.set(t, e), e;
  } catch (e) {
    console.error(
      `Error finding DOM element with selector "${t}":`,
      e
    );
  }
  return C.set(t, null), null;
}, me = (t) => {
  const e = {};
  return Object.entries(t).forEach(([n, o]) => {
    e[n] = k(o);
  }), Object.values(e).every(
    (n) => n !== null
  ) ? !0 : (console.warn("Some elements failed to load:", e), !1);
}, U = (t) => C.get(t) || null, N = {
  SEARCH_INPUT: "[data-js=search-field]",
  SEARCH_FORM: "[data-js=search-form]",
  AUTOSUGGEST_WRAPPER: "[data-js=suggestion-box]",
  RECENT_SEARCH_BOX_WRAPPER: "[data-js=recent-search-box]"
}, ve = "#gnav-data", ye = "#ew-search-autosuggest", Se = {
  ENTER: "Enter",
  ESC: "Escape",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  HOME: "Home",
  END: "End"
}, Ie = "Search Suggestions", Ae = (t = ve) => {
  const {
    enableAutosuggest: e = !1,
    searchAction: s = "",
    useConstructorAutosuggest: n = !1
  } = Y(t);
  return !!e && s === "/search" && !!n;
}, we = (t = ye) => {
  const {
    experienceName: e = "",
    variant: s = ""
  } = Y(t);
  return e === "AutosuggestTest" && s === "variant1";
}, Ee = (t = {}) => {
  const {
    gnavDataJsonSelector: e,
    testConfigJsonSelector: s
  } = t;
  return Ae(e) && we(s) && me(N);
}, xe = (t) => {
  let e;
  if (t) {
    const s = ["gnavDataJsonSelector", "testConfigJsonSelector"];
    typeof t == "string" && t.length && (e = { [s[0]]: t }), typeof t == "object" && Object.keys(t || {}).some((n) => s.includes(n)) && (e = s.reduce((n, o) => (o in t && (n[o] = t[o]), n), {}));
  }
  return e;
}, O = class O {
  /**
   * Get the singleton instance of UserService
   */
  static getInstance() {
    return O.instance || (O.instance = new O()), O.instance;
  }
  /**
   * Gets the online account number from utag_data or by API call
   * @returns A promise that resolves to the online account number or null
   */
  static async getOnlineAccountNumber() {
    const e = window == null ? void 0 : window.utag_data, { isLoggedIn: s, onlineAccountNumber: n } = e || {};
    if (s === "logged in" && n)
      return n;
    if (!e) {
      const o = await O.fetchUser();
      return typeof (o == null ? void 0 : o.accountId) == "string" ? o.accountId : null;
    }
    return null;
  }
  /**
   * Fetches user data from the API
   * @returns A promise that resolves to user data or null
   */
  static async fetchUser() {
    try {
      const e = await fetch("/rest/user/account");
      return e.ok ? await e.json() : null;
    } catch {
      return null;
    }
  }
};
_(O, "instance");
let W = O;
const E = class E {
  constructor(e, s) {
    _(this, "apiKey");
    _(this, "serviceUrl");
    _(this, "baseConfig");
    _(this, "constructorIO");
    if (E.instance)
      throw new Error("Use AutoSuggestClient.getInstance() to access the singleton instance.");
    this.apiKey = e, this.serviceUrl = s, this.baseConfig = {
      resultsPerSection: {
        "Search Suggestions": 10
      }
    }, this.constructorIO = null, E.instance = this;
  }
  static getInstance(e, s) {
    return E.instance || (E.instance = new E(e, s)), E.instance;
  }
  async init() {
    if (!this.constructorIO) {
      const e = await W.getOnlineAccountNumber();
      this.constructorIO = new he({
        apiKey: this.apiKey,
        serviceUrl: this.serviceUrl,
        userId: e || null
      });
    }
    return console.log("AutosuggestClient constructorIO:", this.constructorIO), this.constructorIO;
  }
  async getAutosuggestResults(e, s = this.baseConfig) {
    return (await this.init()).autocomplete.getAutocompleteResults(e, s);
  }
};
_(E, "instance");
let $ = E;
const be = $.getInstance(
  "key_9Mi6wJ14xYHiFlPx",
  "https://ezeubuswo-zone.cnstrc.com/"
), Re = async (t, e) => be.getAutosuggestResults(t, e), Oe = fe(Re, 300, 700), { SEARCH_INPUT: _e, RECENT_SEARCH_BOX_WRAPPER: z } = N, y = X({
  query: "",
  searchFieldIsFocused: !1,
  cleanQuery: I(() => y.query.trim()),
  isValidQuery: I(() => !!y.cleanQuery),
  suggestions: [],
  suggestionsLength: 0
});
function Q(t = _e) {
  let e;
  const s = U(z) || k(z), n = (r) => {
    var c;
    e && ((c = e.parentElement) == null || c.setAttribute("aria-expanded", String(r)), e.setAttribute("aria-expanded", String(r)));
  }, o = oe([]), i = I(
    () => o.value.map(
      (r) => {
        var c;
        return {
          key: (c = r.data.id) == null ? void 0 : c.trim().toLowerCase().replace(/\s+/g, "-"),
          term: r.value
        };
      }
    )
  ), m = async (r) => {
    var b;
    const S = await Oe(r);
    o.value = ((b = S.sections) == null ? void 0 : b["Search Suggestions"]) || [], y.suggestionsLength = i.value.length, y.suggestions = i.value;
  }, h = async () => {
    y.query = e.value, y.searchFieldIsFocused = !0, y.isValidQuery && await m(y.query), setTimeout(() => {
      var c;
      const r = ((c = s == null ? void 0 : s.dataset) == null ? void 0 : c.visible) === "visible";
      (y.isValidQuery && y.searchFieldIsFocused && y.suggestionsLength > 0 || r) && n(!0);
    }, 0);
  }, l = () => {
    y.searchFieldIsFocused = !1, n(!1);
  };
  H(() => {
    e = U(t) || k(t), e == null || e.addEventListener("focus", h), e == null || e.addEventListener("blur", l);
  }), P(() => {
    e.removeEventListener("focus", h), e.removeEventListener("blur", l);
  });
  function p(r) {
    let c;
    H(() => {
      e && typeof r == "function" && (c = (S) => {
        const b = S.target;
        y.query = b.value, r(S);
      }, e.addEventListener("input", c));
    }), P(() => {
      e && e.removeEventListener("input", c);
    });
  }
  function v(r, c) {
    let S;
    H(() => {
      e && typeof r == "function" && (S = (b) => {
        r(b, c);
      }, e.addEventListener("keydown", S));
    }), P(() => {
      e && e.removeEventListener("keydown", S);
    });
  }
  function u(r) {
    e && (e.value = r, y.query = r, console.log("inputEl.value", e.value), console.log("searchInputState.query", y.query));
  }
  function f() {
    e && (e.focus(), console.log("focusOnInputField called"));
  }
  function A() {
    e && (e.blur(), console.log("blurOnInputField called"));
  }
  function w(r) {
    e && r >= 0 ? (e.setAttribute("aria-activedescendant", `autosuggest-result-${r}`), console.log("setActiveDescendant called", r)) : e && (e.setAttribute("aria-activedescendant", ""), console.log("setActiveDescendant called", r));
  }
  function x(r, c) {
    if (console.log("updateAndSubmitSearchForm called", r, c), e && r >= 0 && c) {
      u(c), e.setAttribute("aria-activedescendant", `autosuggest-result-${r}`);
      const S = new CustomEvent(
        "termSelected",
        {
          bubbles: !0,
          cancelable: !0
        }
      );
      e.dispatchEvent(S);
    }
  }
  return {
    searchInputState: y,
    getAutosuggestResultsAndSetSearchInputState: m,
    setAriaExpanded: n,
    updateInputFieldValue: u,
    updateAndSubmitSearchForm: x,
    focusOnInputField: f,
    blurOnInputField: A,
    setActiveDescendant: w,
    watchInputInputEvents: p,
    watchInputKeydownEvents: v
  };
}
const Te = (t, e = {}) => {
  const s = typeof e[t.key] == "function" ? e[t.key] : () => {
  };
  return console.log("event.key:", t.key), {
    handler: s
  };
}, g = X({
  activeIndex: -1
});
function Z() {
  const {
    searchInputState: t,
    updateInputFieldValue: e,
    updateAndSubmitSearchForm: s,
    focusOnInputField: n,
    blurOnInputField: o,
    setActiveDescendant: i
  } = Q(), {
    ENTER: m,
    ESC: h,
    ARROW_UP: l,
    ARROW_DOWN: p,
    ARROW_LEFT: v,
    ARROW_RIGHT: u,
    HOME: f,
    END: A
  } = Se, w = (d) => {
    var F, q;
    console.log((F = d.target) == null ? void 0 : F.id), console.log("select the item");
    const a = (q = t.suggestions[g.activeIndex]) == null ? void 0 : q.term;
    s(g.activeIndex, a);
  }, x = (d) => {
    var a;
    console.log((a = d.target) == null ? void 0 : a.id), console.log("close the list"), g.activeIndex = -1, e(""), o(), n(), console.log("searchInputState.query useListbox", t.query);
  }, r = (d) => {
    var a;
    d.preventDefault(), console.log((a = d.target) == null ? void 0 : a.id), console.log("move up on the list"), console.log("emit an event to SearchSuggestionWrapper"), g.activeIndex <= 0 ? (g.activeIndex = t.suggestionsLength - 1, console.log("listboxState.activeIndex < 0", g.activeIndex)) : g.activeIndex -= 1;
  }, c = (d) => {
    var a;
    d.preventDefault(), console.log((a = d.target) == null ? void 0 : a.id), console.log("move down on the list"), g.activeIndex < 0 && (g.activeIndex = -1), g.activeIndex >= t.suggestionsLength - 1 && (g.activeIndex = -1), g.activeIndex += 1;
  }, S = (d) => {
    var a;
    console.log((a = d.target) == null ? void 0 : a.id), console.log("move left on the input field"), g.activeIndex = -1;
  }, b = (d) => {
    var a;
    console.log((a = d.target) == null ? void 0 : a.id), console.log("move right on the input field"), g.activeIndex = -1;
  }, ee = (d) => {
    var a;
    console.log((a = d.target) == null ? void 0 : a.id), console.log("move to the beginning of the text"), g.activeIndex = -1;
  }, te = (d) => {
    var a;
    console.log((a = d.target) == null ? void 0 : a.id), console.log("move to the end of the text"), g.activeIndex = -1;
  }, J = {
    [m]: w,
    [h]: x,
    [l]: r,
    [p]: c,
    [v]: S,
    [u]: b,
    [f]: ee,
    [A]: te
  };
  return {
    listboxState: g,
    handleKeydown: (d, a = J) => {
      const { isValidQuery: F, searchFieldIsFocused: q } = t;
      F && q && (Te(d, a).handler(d), i(g.activeIndex));
    },
    keydownHandlers: J
  };
}
const Le = ["id", "data-cnstrc-item-section", "data-cnstrc-item-name", "aria-selected", "onMouseover", "onMousedown"], Ce = /* @__PURE__ */ V({
  __name: "SearchListbox",
  props: {
    suggestions: {
      type: Array,
      required: !0
    },
    query: {
      type: String,
      default: ""
    },
    c9rSection: {
      type: String,
      required: !0
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  setup(t) {
    const e = t, {
      listboxState: s
    } = Z(), {
      setActiveDescendant: n,
      updateAndSubmitSearchForm: o
    } = Q(), i = I(() => {
      const {
        termParts: l
      } = e.suggestions[0];
      return Array.isArray(l) && l.length > 0;
    }), m = I(() => {
      const {
        activeIndex: l
      } = s, p = l >= 0 ? l : e.activeIndex;
      return console.log("currentIndex: ", p), p;
    }), h = (l) => {
      s.activeIndex = l, n(l);
    };
    return (l, p) => t.suggestions.length > 0 ? (R(), K(T(pe), {
      key: 0,
      id: "gnav-suggestion-list",
      "aria-label": "Search Suggestions",
      role: "listbox",
      class: "search-listbox",
      onMouseleave: p[0] || (p[0] = (v) => h(-1))
    }, {
      default: ce(() => [(R(!0), L(M, null, j(t.suggestions, (v, u) => (R(), L("li", {
        id: `autosuggest-result-${u}`,
        key: v.key,
        "data-cnstrc-item-section": e.c9rSection,
        "data-cnstrc-item-name": v.term,
        role: "option",
        class: B(["search-listbox__list-item", {
          "search-listbox__list-item--active search-term": u === m.value
        }]),
        "aria-selected": u === m.value,
        onMouseover: (f) => h(u),
        onMousedown: ae((f) => T(o)(u, v.term), ["left"])
      }, [i.value ? (R(!0), L(M, {
        key: 0
      }, j(v.termParts, (f) => (R(), L("span", {
        key: f.key,
        class: B({
          "search-listbox__list-item--query-text": f.queryText
        })
      }, G(f.text), 3))), 128)) : (R(), L(M, {
        key: 1
      }, [ie(G(v.term), 1)], 64))], 42, Le))), 128))]),
      _: 1
    })) : re("", !0);
  }
}), Fe = (t, e) => {
  const s = t.__vccOpts || t;
  for (const [n, o] of e)
    s[n] = o;
  return s;
}, qe = /* @__PURE__ */ Fe(Ce, [["__scopeId", "data-v-2553261e"]]), De = /* @__PURE__ */ V({
  __name: "SearchAutosuggest",
  props: {
    suggestions: {
      type: Array,
      required: !0,
      validator(t) {
        return Array.isArray(t) && t.length <= 10;
      }
    },
    query: {
      type: String,
      required: !0
    },
    c9rSection: {
      type: String,
      required: !0
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  setup(t) {
    const e = t, s = I(() => e.suggestions.slice(0, 10)), n = I(() => e.query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")), o = I(() => new RegExp(`(\\b${n.value}\\b|${n.value})`, "gi")), i = I(() => s.value.map((m) => {
      const {
        term: h,
        key: l
      } = m;
      return {
        termParts: h.split(o.value).filter((u) => u !== "").map((u, f) => ({
          text: u.replace(/ /g, " "),
          queryText: u.toLowerCase() === n.value.toLowerCase(),
          key: `${l}-part-${f}`
        })),
        ...m
      };
    }));
    return (m, h) => (R(), K(qe, {
      suggestions: i.value,
      query: e.query,
      "c9r-section": e.c9rSection,
      "active-index": e.activeIndex
    }, null, 8, ["suggestions", "query", "c9r-section", "active-index"]));
  }
}), ke = /* @__PURE__ */ V({
  __name: "SearchInputSuggestions",
  setup(t) {
    const {
      AUTOSUGGEST_WRAPPER: e
    } = N, s = k(e), {
      searchInputState: n,
      getAutosuggestResultsAndSetSearchInputState: o,
      focusOnInputField: i,
      blurOnInputField: m,
      watchInputInputEvents: h,
      watchInputKeydownEvents: l,
      setAriaExpanded: p
    } = Q(), {
      handleKeydown: v,
      keydownHandlers: u,
      listboxState: f
    } = Z(), A = I(() => n.isValidQuery && n.suggestionsLength > 0 && n.searchFieldIsFocused), w = I(() => A.value ? "autosuggest" : "none");
    return ue(A, () => {
      s.dataset.visible = A.value ? "visible" : "hidden";
    }), h(async () => {
      n.cleanQuery ? (f.activeIndex = -1, await o(n.query), n.suggestionsLength ? p(!0) : p(!1)) : (m(), i());
    }), l(v, u), (x, r) => {
      var c;
      return le((R(), K(De, {
        "c9r-section": T(Ie),
        suggestions: T(n).suggestions,
        query: T(n).cleanQuery,
        "active-index": (c = T(f)) == null ? void 0 : c.activeIndex,
        class: "search-input-suggestions"
      }, null, 8, ["c9r-section", "suggestions", "query", "active-index"])), [[de, w.value === "autosuggest"]]);
    };
  }
}), Ke = (t) => {
  if (Ee(xe(t))) {
    const { AUTOSUGGEST_WRAPPER: e } = N, s = U(e);
    try {
      ge(ke).mount(s);
    } catch (n) {
      console.error(n);
    }
  }
};
export {
  Ke as default
};
